
import { Component, Mixins, Watch } from "vue-property-decorator";
import mixin from "./mixin";
import { getModule } from "vuex-module-decorators";
import BarcodeOrderModule from "@/store/modules/barcodeSystem/barcodeOrder";
import * as modals from "@/lib/modals";
import { CreateOrderFromHeaderNumberRequest } from "@/models/api/barcodeSystem/barcodeOrders/createOrderFromHeaderNumber";

@Component({
  name: modals.createBarcodeOrderFromHeaderNumberModal
})
export default class CreateBarcodeOrderFromHeaderNumberModal extends Mixins(mixin) {
  barcodeOrderModule: BarcodeOrderModule = getModule(BarcodeOrderModule);

  async createOrder() {
    this.isLoading = true;
    
    if(this.selectedItems && this.selectedItems.length == 1)
    {
      var request = {
        orderHeaderNumber: this.selectedItems[0].headerNumber
      } as CreateOrderFromHeaderNumberRequest

      await this.barcodeOrderModule.createBarcodeOrderFromHeaderNumber(request)
        .then(response => {
          this.addActionResult({
            number: request.orderHeaderNumber,
            success: true,
            message: `Barcode order data successfully created.`
          });
          this.barcodeOrderModule.linkInventoryToOrderShortcutAction({selectedItems: [{barcodeOrderId: response.data.resource.id}]})
        })
        .catch(error => {
          this.addActionResult({
            number: request.orderHeaderNumber,
            success: false,
            message: error.response.data.message,
            errors:
              error.response.data && error.response.data.errors ? error.response.data.errors : null,
            errorMessages:
              error.response.data && error.response.data.errorMessages
              ? error.response.data.errorMessages
              : null
          });
          this.hideModal();
        })
        .finally(() => {
          if (this.isLoading) this.isLoading = false;
        });
    }
  }
}
